import React from 'react';

export const MessageOptions = ({
  options,
  selectedOption,
  clickedOption,
  handleOptionClick,
}: {
  options: string[];
  selectedOption: string;
  clickedOption: string | null;
  handleOptionClick: (option: string) => void;
}) => {
  if (selectedOption !== '') return null;

  return (
    <div className="mt-4 flex flex-col space-y-2">
      {options.map((option, index) => (
        <div key={index} className="flex justify-end">
          <button
            onClick={() => handleOptionClick(option)}
            className={`rounded-[10px] px-4 py-2 text-left text-sm transition-all duration-500 ease-out ${
              clickedOption === option
                ? 'border-transparent bg-secondary text-secondary-foreground'
                : 'border border-ring text-foreground hover:bg-card'
            }`}
          >
            {option}
          </button>
        </div>
      ))}
    </div>
  );
};
